import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';

@inject(HttpClient)
export class StatusService {
    constructor(http) {
        this.http = http;
        this.singular = 'status';
        this.plural = 'statuses';
        this.editor = PLATFORM.moduleName('pages/system-fields/statuses/editor/index');
    }

    async filter(loadOptions) {
        const response = await this.http.fetch(`statuses/filter/${loadOptions}`);
        return await response.json();
    }

    async create(status) {
        await this.http.fetch('statuses', { method: 'POST', body: json(status) });
    }

    async update(status) {
        await this.http.fetch(`statuses/${status.id}`, { method: 'PUT', body: json(status) });
    }

    async delete(id) {
        await this.http.fetch(`statuses/${id}`, { method: 'DELETE' });
    }

    async getById(id) {
        const response = await this.http.fetch(`statuses/${id}`);
        return await response.json();
    }

    async filterTopThree(query) {
        if (query == null || query.length === 0) return [];
        const response = await this.http.fetch(`statuses/top-three/${query}`);
        return await response.json();
    }
}